import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { TarjetaComponent } from './tarjeta/tarjeta.component';
import { FormsModule } from '@angular/forms';
import { LogoComponent } from './logo/logo.component';


import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';
import { DashboardComponent } from './dashboard/dashboard.component';
import { IconoPersonaComponent } from './tarjeta/icono-persona/icono-persona.component';
import { TarjetadashComponent } from './dashboard/tarjetadash/tarjetadash.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingComponent } from './helper/loading/loading.component';
import { PrintTicketComponent } from './print-ticket/print-ticket.component';
import { PimaryComponentComponent } from './pimary-component/pimary-component.component';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
/*SERVICIOS*/
import {EncrDecrServiceService} from './services/encr-decr-service.service';
import {LogInterceptorService} from './services/log-interceptor.service';
import { ReportComponent } from './reporte/report/report.component'
import { QRCodeModule } from 'angularx-qrcode';
import { ValidarTicketComponent } from './validar-ticket/validar-ticket.component';

@NgModule({
  declarations: [
    AppComponent,
    TarjetaComponent,
    LogoComponent,
    DashboardComponent,
    IconoPersonaComponent,
    TarjetadashComponent,
    LoadingComponent,
    PrintTicketComponent,
    PimaryComponentComponent,
    LoginComponent,
    ReportComponent,
    ValidarTicketComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    NoopAnimationsModule,
    FormsModule,
    CommonModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(),
    HttpClientModule,
    QRCodeModule


  ],
  providers: [EncrDecrServiceService,{
    provide: HTTP_INTERCEPTORS,
    useClass: LogInterceptorService,
    
    multi:true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
